module.exports = __webpack_public_path__ + "static/media/step-7-en.ad7d1bf5.jpg";